import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {ExternalHistoryEvent, ExternalHistoryResponse} from 'src/app/shared/models/request';
import {ApiService} from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-traveller-history-panel',
  templateUrl: './traveller-history-panel.component.html',
  styleUrls: ['./traveller-history-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TravellerHistoryPanelComponent implements OnChanges {

  @Input() paymentId = '';

  isOpen = false;
  loaded = false;
  externalHistoryResponse: ExternalHistoryResponse | null = null;
  entryExitEvents: (ExternalHistoryEvent & {source: 'event'})[] = [];
  complianceEvents: (ExternalHistoryEvent & {source: 'compliance_logs'})[] = [];
  visaEvents: (ExternalHistoryEvent & {source: 'visa'})[] = [];
  permitEvents: (ExternalHistoryEvent & {permitType: string})[] = [];
  entryExitExpanded = false;
  complianceExpanded = false;
  visaExpanded = false;
  permitExpanded = false;
  isLoading = false;

  constructor(private readonly api: ApiService,
              private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.paymentId) {
      this.loaded = false;
      this.isOpen = false;
      this.externalHistoryResponse = null;
      this.entryExitEvents = [];
      this.complianceEvents = [];
      this.visaEvents = [];
      this.permitEvents = [];
    }
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
    if(this.isOpen && !this.loaded && !this.isLoading) {
      this.loadTravellerHistory();
    }
    this.cdr.markForCheck();
  }

  private loadTravellerHistory(): void {
    if(!this.paymentId) return;
    this.isLoading = true;
    this.cdr.markForCheck();

    this.api.payment(this.paymentId, false, false, false, true, true).then(result => {
      this.externalHistoryResponse = result.externalHistoryResponse || null;
      if(this.externalHistoryResponse?.events) {
        this.entryExitEvents = this.externalHistoryResponse.events.filter((e): e is ExternalHistoryEvent & {source: 'event'} => 'source' in e && e.source === 'event');
        this.complianceEvents = this.externalHistoryResponse.events.filter((e): e is ExternalHistoryEvent & {source: 'compliance_logs'} => 'source' in e && e.source === 'compliance_logs');
        this.visaEvents = this.externalHistoryResponse.events.filter((e): e is ExternalHistoryEvent & {source: 'visa'} => 'source' in e && e.source === 'visa');
        this.permitEvents = this.externalHistoryResponse.events.filter((e): e is ExternalHistoryEvent & {permitType: string} => 'permitType' in e);
      }
      this.loaded = true;
      this.isLoading = false;
      this.cdr.markForCheck();
    }).catch(() => {
      this.loaded = true;
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }
}
